$(function(){
  if ($("[class^='lp_bookmark_banner']").length) {
    $(window).scroll(function () {
      // 何%スクロールしたか
      var height = $('body').height(),//ページ全体の高さ代入
          scroll = $(window).scrollTop(), //スクロール位置代入
          percentFin = (scroll / height) * 100; //1%を計算

      // 1/3 スクロールしたら表示させる
      if(percentFin >= 25) {
        $('.lpLinkButton').show()
      }
    })

    // スクロールが短い or 全画面で表示できている場合
    var footer = $('#GlobalFooter'),
        winScroll = $(window).scrollTop(), //スクロールの上下位置を取得
        winHeight = $(window).height(), //ウィンドウの高さを取得
        scrollPos = winScroll + winHeight;//上記の合計（スクロールポジション）

    if(footer.offset().top < scrollPos) {
      $('.lpLinkButton').show()
    }
  }
});
